"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VoucherStore = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reduxConnect = require("redux-connect");

var _reduxForm = require("redux-form");

var _reactRouterRedux = require("react-router-redux");

var _voucherStoreValidator = require("./voucherStoreValidator");

var _voucherStoreValidator2 = _interopRequireDefault(_voucherStoreValidator);

var _VoucherOrderForm = require("../../components/vouchers/VoucherOrderForm");

var _VoucherOrderForm2 = _interopRequireDefault(_VoucherOrderForm);

var _VoucherOrderConfirmation = require("../../components/vouchers/VoucherOrderConfirmation");

var _VoucherOrderConfirmation2 = _interopRequireDefault(_VoucherOrderConfirmation);

var _VoucherOrderSuccessPanel = require("../../components/vouchers/VoucherOrderSuccessPanel");

var _VoucherOrderSuccessPanel2 = _interopRequireDefault(_VoucherOrderSuccessPanel);

var _VoucherOrderPaymentPanel = require("../../components/vouchers/VoucherOrderPaymentPanel");

var _VoucherOrderPaymentPanel2 = _interopRequireDefault(_VoucherOrderPaymentPanel);

var _vouchers = require("../../redux/modules/vouchers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherStore = exports.VoucherStore = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VoucherStore, _Component);

  function VoucherStore() {
    (0, _classCallCheck3.default)(this, VoucherStore);
    return (0, _possibleConstructorReturn3.default)(this, (VoucherStore.__proto__ || (0, _getPrototypeOf2.default)(VoucherStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(VoucherStore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getShoppingCart();
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      var _props = this.props,
          vouchers = _props.vouchers,
          deleteShoppingCart = _props.deleteShoppingCart;

      if (!vouchers.placeOrderSuccess && nextProps.vouchers.placeOrderSuccess) {
        deleteShoppingCart();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Osta vastaanottolipukkeita" }),
        this.defineContent()
      );
    }
  }, {
    key: "defineContent",
    value: function defineContent() {
      var _props2 = this.props,
          location = _props2.location,
          pathname = _props2.pathname,
          query = _props2.query,
          vouchers = _props2.vouchers,
          confirmPayment = _props2.confirmPayment,
          formPage = _props2.formPage,
          confirmPage = _props2.confirmPage;


      if (vouchers.placeOrderSuccess || vouchers.confirmPaymentSuccess) {
        return _react2.default.createElement(_VoucherOrderSuccessPanel2.default, this.props);
      }

      if (pathname.includes("/success") && query) {
        var orderId = pathname.match(/\/([0-9]+)\/success$/)[1];
        return _react2.default.createElement(_VoucherOrderPaymentPanel2.default, {
          orderId: orderId,
          confirmPayment: confirmPayment,
          query: query
        });
      }

      if (vouchers.confirmPage) {
        return _react2.default.createElement(_VoucherOrderConfirmation2.default, (0, _extends3.default)({}, this.props, { onBack: formPage }));
      }

      return _react2.default.createElement(_VoucherOrderForm2.default, (0, _extends3.default)({}, this.props, {
        onSubmit: confirmPage,
        paymentError: this.isFailurePage()
      }));
    }
  }, {
    key: "isFailurePage",
    value: function isFailurePage() {
      return this.props.pathname.includes("/failure");
    }
  }]);
  return VoucherStore;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  orderType: _react.PropTypes.string,
  company: _react.PropTypes.object,
  getShoppingCart: _react.PropTypes.func.isRequired,
  insertCartItem: _react.PropTypes.func.isRequired,
  removeCartItem: _react.PropTypes.func.isRequired,
  deleteShoppingCart: _react.PropTypes.func.isRequired,
  updateQuantity: _react.PropTypes.func.isRequired,
  confirmPage: _react.PropTypes.func.isRequired,
  formPage: _react.PropTypes.func.isRequired,
  vouchers: _react.PropTypes.object.isRequired,
  query: _react.PropTypes.object,
  pathname: _react.PropTypes.string.isRequired,
  confirmPayment: _react.PropTypes.func.isRequired,
  resetVoucherState: _react.PropTypes.func.isRequired
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    if (!(0, _vouchers.isReceptionPlacesLoaded)(getState())) {
      promises.push(dispatch((0, _vouchers.loadReceptionPlaces)()));
    }

    return _promise2.default.all(promises);
  }
}])((0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    orderType: state.auth.orderType,
    company: state.company.company,
    vouchers: state.vouchers,
    pathname: state.routing.locationBeforeTransitions.pathname,
    query: state.routing.locationBeforeTransitions.query
  };
}, {
  insertCartItem: _vouchers.insertCartItem,
  getShoppingCart: _vouchers.getShoppingCart,
  removeCartItem: _vouchers.removeCartItem,
  updateQuantity: _vouchers.updateQuantity,
  placeOrder: _vouchers.placeOrder,
  deleteShoppingCart: _vouchers.deleteShoppingCart,
  confirmPage: _vouchers.confirmPage,
  formPage: _vouchers.formPage,
  confirmPayment: _vouchers.confirmPayment,
  resetVoucherState: _vouchers.resetVoucherState,
  changeOrderType: _vouchers.changeOrderType,
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "voucherOrder",
  fields: ["voucher", "business_id", "company_name", "first_name", "last_name", "address", "postal_code", "city", "email", "phone", "order_reference"],
  validate: _voucherStoreValidator2.default
})(VoucherStore)));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/VoucherStore/VoucherStore.js
 ** module id = 1251
 ** module chunks = 0
 **/